module.exports = __webpack_public_path__ + "static/ASCOVIME - dawaCoordinator Registering Patients 2_2019-5e1c2552a4e71a01309d297d1bcd59b2.jpg";